import { useContext } from 'react';

import { DirectRequestFormContext } from '@/context/directRequestFormContext';

export function useDirectRequestFormContext() {
  return useContext(DirectRequestFormContext);
}
